import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_MANAGERS:
      return { ..._.mapKeys(action.payload, "Id") };
    default:
      return state;
  }
};
